/**
 * Check if an error is from request cancellation/abort (user navigation, unmount, etc.).
 * These should never be shown as real errors to users.
 */
export const isAbortError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  const err = error as {
    name?: string;
    message?: string;
    code?: string | number;
    cause?: unknown;
  };
  const msg = typeof err.message === "string" ? err.message.toLowerCase() : "";
  return (
    err.name === "AbortError" ||
    msg.includes("aborted") ||
    msg.includes("signal is aborted") ||
    msg.includes("the user aborted") ||
    err.code === "20" || // Fetch abort (string)
    err.code === 20 || // Fetch abort (numeric — common in PostgREST / RQ)
    err.code === "ERR_ABORTED" ||
    (err.cause != null && isAbortError(err.cause))
  );
};
